/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_TitleInputs */

const en_agb_title = /** @type {(inputs: Agb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms and Conditions (AGB)`)
};

const de_agb_title = /** @type {(inputs: Agb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine Geschaeftsbedingungen (AGB)`)
};

const fr_agb_title = /** @type {(inputs: Agb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conditions Générales de Vente (CGV)`)
};

const es_agb_title = /** @type {(inputs: Agb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condiciones generales (AGB)`)
};

const it_agb_title = /** @type {(inputs: Agb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condizioni generali (AGB)`)
};

const nl_agb_title = /** @type {(inputs: Agb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algemene Voorwaarden (AV)`)
};

const pl_agb_title = /** @type {(inputs: Agb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogólne Warunki Handlowe (OWH)`)
};

const fi_agb_title = /** @type {(inputs: Agb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yleiset ehdot (AGB)`)
};

const da_agb_title = /** @type {(inputs: Agb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vilkår og betingelser (AGB)`)
};

const sv_agb_title = /** @type {(inputs: Agb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allmänna villkor (AGB)`)
};

/**
* | output |
* | --- |
* | "Terms and Conditions (AGB)" |
*
* @param {Agb_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_title = /** @type {((inputs?: Agb_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_title(inputs)
	if (locale === "fr") return fr_agb_title(inputs)
	if (locale === "es") return es_agb_title(inputs)
	if (locale === "it") return it_agb_title(inputs)
	if (locale === "nl") return nl_agb_title(inputs)
	if (locale === "pl") return pl_agb_title(inputs)
	if (locale === "fi") return fi_agb_title(inputs)
	if (locale === "da") return da_agb_title(inputs)
	if (locale === "sv") return sv_agb_title(inputs)
	return en_agb_title(inputs)
});